import React from 'react'

import Alert from '../../../../../1stlog-ui/src/components/Alert'
import { useField } from '../../../../../1stlog-ui/src/components/Field'
import { useForm } from '../../../../../1stlog-ui/src/components/Form'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import { useProductSettings } from '../../Products'
import useOrderEntry from '../../useOrderEntry'
import CustomsTerms from '../CustomsTerms'
import InvoiceUpload from '../InvoiceUpload'
import CustomsCollection from './CustomsCollection'
import useCustoms from './useCustoms'

const Customs = (
  props: Omit<IOrderEntryCardProps, 'title' | 'children'>,
): React.ReactElement => {
  const form = useForm()

  const { isCustomsRequired } = useCustoms()

  const { currentCustomer } = useOrderEntry()

  const { enableDutiableProducts, isIncotermsHidden } = useProductSettings()

  const proformaInvoice = useField('proformaInvoice')

  if (!isCustomsRequired) {
    return <></>
  }

  return (
    <>
      <InvoiceUpload {...props} />
      {enableDutiableProducts && (
        <OrderEntryCard
          {...props}
          title={i18n.t('title_customs_goods', 'Zollpflichtige Waren')}
        >
          {!proformaInvoice && (
            <div>
              <Alert info>
                {i18n.t(
                  'info_not_required_customs_goods',
                  'Da Sie eine Handelsrechnung angeben, ist die Angabe zollpflichtiger Waren hier nicht notwendig. Optional können Sie allerdings Zollpflichtige Waren angeben.',
                )}
              </Alert>
            </div>
          )}
          <CustomsCollection
            currentCustomer={currentCustomer}
            name="customs"
            exportCountryField="pickup.address.country"
            importCountryField="delivery.address.country"
            isOptional={!proformaInvoice}
          />
        </OrderEntryCard>
      )}
      {!isIncotermsHidden && <CustomsTerms {...props} />}
    </>
  )
}

export default Customs

export { default as useCustoms } from './useCustoms'
